<script setup>

const route = useRoute()

const props = defineProps({
    light: Boolean,
    breadcrumbs: {
        type: Array,
        default: () => [],
    },
})

const removeTrailingSlashes = (str) => { return str.replace(/\/+$/, ''); }

</script>
<template>
    <nav aria-label="Breadcrumb" class="breadcrumbs" v-if="breadcrumbs && breadcrumbs.length > 1" :class="{ 'light': light }">
        <div class='container'>
            <ol>
                <li v-for="(item, index) in breadcrumbs">
                    <MessLink v-if="item.name && item.item && removeTrailingSlashes(item.item) !== removeTrailingSlashes(route.path)" :href="item.item" class="base">
                        <span v-html="item.name" tag="span" />
                    </MessLink>
                    <span v-else class="active">
                        <span v-html="item.name" tag="span" />
                    </span>
                    <span class="pipe" v-if="index < breadcrumbs.length - 1">/</span>
                </li>
            </ol>
        </div>
    </nav>
</template>

<style lang="scss">
html {
    
    --announcement-height: 0px;

    .page-wrapper[data-model=blog] .root-container .breadcrumbs .container {
        max-width: 1130px;
    }

    .breadcrumbs {
        position: absolute;
        left: 0;
        top: calc(var(--header-height) + 1rem);
        letter-spacing: 0.020625rem;
        font-weight: 300;
        z-index: 5;
        width: 100vw;
        width: 100dvw;

        transition: top 250ms ease-in-out;

        &.light {
            ol {
                li { color: var(--teal-gray); }
                a {
                    color: var(--teal-gray);
                    @include hover {
                        color: var(--teal);
                    }
                }
            }
        }

        ol {
            --spacing: 0.5rem;
            display: flex;
            gap: var(--spacing);
            overflow: hidden;
            color: var(--sage);
            width: 100%;
            height: 1.2rem;

            font-size: calc(11 / var(--base-fs) * 1rem);
            font-weight: 300;
            line-height: 1.085625rem;
            letter-spacing: 0.020625rem;

            .pipe {
                margin-left: var(--spacing);
            }

            a {
                color: var(--sage);
                text-decoration: none;
                
                @include hover {
                    text-decoration: underline;
                    text-underline-offset: 2px;
                    color: var(--cream);
                }
            }
        }
    }
}
</style>
